import React from 'react';
import { injectIntl } from 'react-intl';

import ListFilterAsyncMultiple from 'components/layout/list/ListFilterAsyncMultiple';
import {getNameInCurrentLanguage} from "helpers/intl";
import _, {forEach as _forEach} from "lodash";

class ListFilterCategory extends React.Component {
  getCategoryPathName = (data) => {
    const { appIntl, categoriesSettings } = this.props;
    let categoryName = "";
    if(typeof data.path !== undefined && typeof data.path === 'string'){
      let path = data.path.split(",");
      let cleanedPath = [];
      _forEach(path, (singlePath, i) => {
        if (singlePath !== "" && singlePath !== "0") {
          cleanedPath.push(singlePath);
        }
      });
      _forEach(cleanedPath, (singleCleanedPath, i) => {
        if(cleanedPath.length-1 > i){
          const index = _.findIndex(categoriesSettings?.list, category => category.id === singleCleanedPath);
          if (index !== -1) {
            categoryName = categoryName + getNameInCurrentLanguage(categoriesSettings?.list[index].name, appIntl) + " > "
          }
        }
      });
    }
    return categoryName;
  }


  listItemFormatter = category => this.getCategoryPathName(category) + " " + getNameInCurrentLanguage(category.name, this.props.appIntl);

  listItemId = category => {
    return category.id;
  };

  render() {
    const {
      intl: { messages },
    } = this.props;

    return (
      <ListFilterAsyncMultiple
        title={messages.categories}
        listName="categories"
        listUrl="/api/categories.json"
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        listUrlData={{
          filters: {},
        }}
        paramName="category"
        complete
      />
    );
  }
}
ListFilterCategory.defaultProps = {};

export default injectIntl(ListFilterCategory);
